import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import FeedbackIcon from '@atlaskit/icon/core/feedback';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';
import { withFlags } from '@confluence/flags/entry-points/withFlags';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode';

import { SpaceRolesFeedbackCollector } from './SpaceRolesFeedbackCollector';

const i18n = defineMessages({
	buttonText: {
		id: 'space-roles.feedback-collector.button-text',
		defaultMessage: 'Give feedback',
		description: 'Text for a button that opens a feedback collector',
	},
	flagTitle: {
		id: 'space-roles.feedback-collector.flag-title',
		defaultMessage: 'Feedback submitted, thank you!',
		description: 'Title for a flag that appears after feedback is submitted',
	},
});

const FeedbackCollectorButtonComponent = ({
	flags,
	source,
	appearance = 'default',
}: {
	flags: FlagsStateContainer;
	source: string;
	appearance?: 'default' | 'subtle';
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const { formatMessage } = useIntl();
	const { isRbacEnabled } = useSpaceRoleMode();

	return isRbacEnabled ? (
		<>
			<Button iconBefore={FeedbackIcon} appearance={appearance} onClick={() => setIsOpen(true)}>
				{formatMessage(i18n.buttonText)}
			</Button>
			<SpaceRolesFeedbackCollector
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false);
				}}
				onSubmit={() => {
					void flags.showSuccessFlag({
						title: formatMessage(i18n.flagTitle),
						isAutoDismiss: true,
					});
				}}
				source={source}
			/>
		</>
	) : null;
};

export const FeedbackCollectorButton = withFlags(FeedbackCollectorButtonComponent);
